import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations directly to avoid http-backend issues in simple setups
import enCommon from './locales/en/common.json';
import ptBRCommon from './locales/pt-BR/common.json';

const resources = {
    en: { common: enCommon },
    'pt-BR': { common: ptBRCommon } // Ensure strict matching
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',
        debug: false,
        ns: ['common'],
        defaultNS: 'common',
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
